import { useEffect, useState } from 'react'
import { DEBIT_CARD_ACCOUNT_TYPES } from '../constants'
import { LinkType } from '../types'
import { decideLinkType } from '../utils'

export interface UseLinkTypeParams {
  accountType: string
  accountId: string
}

type UseLinkType = (params: UseLinkTypeParams) => LinkType

export const useLinkType: UseLinkType = ({ accountType, accountId }) => {
  const [linkType, setLinkType] = useState<LinkType>({ tag: 'none' })
  const isDebitCardAccountType = DEBIT_CARD_ACCOUNT_TYPES.includes(accountType)

  useEffect(() => {
    const invokeDecideLinkType: () => Promise<LinkType | void> = async () => {
      const result = await decideLinkType({
        isDebitCardAccountType,
        accountId,
      })
      setLinkType(result)
    }
    invokeDecideLinkType()
  }, [isDebitCardAccountType, accountId])

  return linkType
}
